import { render, staticRenderFns } from "./OnRegister.vue?vue&type=template&id=a7c96fda"
import script from "./OnRegister.vue?vue&type=script&lang=js"
export * from "./OnRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports